/** App environment axis both brands expose as `environment.appEnv`. */
export type AnalyticsAppEnv = 'local' | 'dev' | 'prd';

/**
 * Whether analytics must stay silent for the given environment.
 *
 * `libs/analytics/SPEC.md` §4 requires no outbound PostHog calls from `local`
 * or `dev`. Each brand's `app.config.ts` feeds the result into
 * {@link AnalyticsConfig.disabled}, so the rule lives here rather than being
 * re-derived per app.
 *
 * @param appEnv The environment the app was built for.
 * @returns `true` when PostHog must not be initialized.
 * @example
 * provideAnalytics({
 *   disabled: isAnalyticsDisabledForEnv(environment.appEnv),
 *   posthogKey: environment.posthogKey ?? '',
 * });
 */
export const isAnalyticsDisabledForEnv = (appEnv: AnalyticsAppEnv): boolean =>
  appEnv === 'local' || appEnv === 'dev';
